import React from 'react'

function Automations() {
  return (
    <div>Automations</div>
  )
}

export default Automations